import type { Dispatch } from "@reduxjs/toolkit";
import { getRuntimeConfig } from "~/common/config/runtimeConfig";
import { startSessionExpiryLogout } from "~/features/auth/api/doLogout";
import { sessionExpired } from "~/features/auth/session/sessionExpirationSlice";

export const sessionIsPunchout = () => getRuntimeConfig().punchoutMode !== null;

export const beginSessionExpiration = (dispatch: Dispatch) => {
  dispatch(sessionExpired(sessionIsPunchout()));
  return startSessionExpiryLogout();
};
